<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <!--工具条-->
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            <div class="dp-dept-hint">
                <span class="dp-dept-hint__label">所属机构</span>
                <span class="dp-dept-hint__value">{{ currentDepartmentName || '全部' }}</span>
            </div>
            <div class="tbl-scroll-host">
            <el-table v-loading="listLoading" :data="list" height="100%" style="width: 100%" highlight-current-row
                @row-click="selectCurrentRow" ref="table">
                <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                <el-table-column prop="ScreenName" label="名称" min-width="120" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ScreenCode" label="编码" min-width="100" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="访问链接" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleCopyLink(scope.row.ScreenCode)">复制链接</el-button>
                        <el-button type="text" @click="handleOpenLink(scope.row.ScreenCode)">打开</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="所属校区" min-width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.CampusName === '待重新选择校区'" class="campus-warn">待重新选择校区</span>
                        <span v-else>{{ scope.row.CampusName || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="绑定年级" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button
                            v-if="parseGradeNames(scope.row.GradeNames).length"
                            type="text"
                            size="small"
                            icon="el-icon-office-building"
                            class="dsm-grade-link-btn"
                            @click.stop="openGradeViewDialog(scope.row)">
                            已绑定 {{ parseGradeNames(scope.row.GradeNames).length }} 个年级
                        </el-button>
                        <el-tag v-else size="small" type="warning" effect="plain" class="dsm-scope-tag">
                            <i class="el-icon-warning-outline"></i> 未绑定年级
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="状态配色" width="180" align="center" class-name="color-column">
                    <template slot-scope="scope">
                        <div class="table-color-preview">
                            <span class="color-badge" :style="{ backgroundColor: scope.row.PendingColor || '#3b82f6' }" @click.stop="openColorDialog(scope.row)" title="待放学状态颜色 (点击直接修改)">
                                待
                            </span>
                            <span class="color-badge" :style="{ backgroundColor: scope.row.DismissingColor || '#ef4444' }" @click.stop="openColorDialog(scope.row)" title="放学中状态颜色 (点击直接修改)">
                                中
                            </span>
                            <span class="color-badge" :style="{ backgroundColor: scope.row.FinishedColor || '#10b981' }" @click.stop="openColorDialog(scope.row)" title="已放学状态颜色 (点击直接修改)">
                                已
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" min-width="120" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="170" align="center">
                    <template slot-scope="scope">
                        {{ formatTime(scope.row.CreateTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center" fixed="right">
                    <template slot-scope="scope">
                        <div class="table-actions">
                            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <div class="pagination-container">
                <el-pagination
                    layout="total, prev, pager, next"
                    :current-page="page"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="handleCurrentChange"
                    style="float: right"
                />
            </div>

            <!-- Dialog -->
            <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
                <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="100px"
                    style="width: 100%; padding-right: 20px">
                    <el-form-item label="名称" prop="ScreenName">
                        <el-input v-model="temp.ScreenName" placeholder="如：南门大屏" />
                    </el-form-item>
                    <el-form-item label="编码" prop="ScreenCode">
                        <el-input v-model="temp.ScreenCode" placeholder="唯一标识"
                            style="width: 70%; margin-right: 10px;" />
                        <el-button type="primary" size="small" @click="generateRandomCode">随机生成</el-button>
                    </el-form-item>
                    <el-form-item label="所属校区" prop="CampusId">
                        <el-select v-model="temp.CampusId" placeholder="请先选择校区" style="width: 100%"
                            @change="handleCampusChange">
                            <el-option v-for="item in campusOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="绑定年级" prop="GradeIds">
                        <el-select v-model="temp.GradeIds" multiple :disabled="!temp.CampusId"
                            :placeholder="temp.CampusId ? '请选择年级(可多选)' : '请先选择校区'" style="width: 100%">
                            <el-option v-for="item in gradeOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="待放学颜色" prop="PendingColor">
                        <div class="color-choice-bar">
                            <span v-for="color in presetColorsList" :key="color.hex" 
                                  class="preset-color-block" 
                                  :class="{ 'is-active': (temp.PendingColor || '').toLowerCase() === color.hex.toLowerCase() }" 
                                  :style="{ backgroundColor: color.hex }" 
                                  :title="color.label"
                                  @click="temp.PendingColor = color.hex">
                            </span>
                            <el-color-picker v-model="temp.PendingColor" size="small" :class="{ 'is-custom-active': isCustomColor(temp.PendingColor) }" title="自定义颜色 (点击打开调色盘)"></el-color-picker>
                            <span class="color-text-value" :style="{ color: temp.PendingColor || '#3b82f6' }">
                                {{ getColorName(temp.PendingColor || '#3b82f6') }} ({{ temp.PendingColor || '#3b82f6' }})
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item label="放学中颜色" prop="DismissingColor">
                        <div class="color-choice-bar">
                            <span v-for="color in presetColorsList" :key="color.hex" 
                                  class="preset-color-block" 
                                  :class="{ 'is-active': (temp.DismissingColor || '').toLowerCase() === color.hex.toLowerCase() }" 
                                  :style="{ backgroundColor: color.hex }" 
                                  :title="color.label"
                                  @click="temp.DismissingColor = color.hex">
                            </span>
                            <el-color-picker v-model="temp.DismissingColor" size="small" :class="{ 'is-custom-active': isCustomColor(temp.DismissingColor) }" title="自定义颜色 (点击打开调色盘)"></el-color-picker>
                            <span class="color-text-value" :style="{ color: temp.DismissingColor || '#ef4444' }">
                                {{ getColorName(temp.DismissingColor || '#ef4444') }} ({{ temp.DismissingColor || '#ef4444' }})
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item label="已放学颜色" prop="FinishedColor">
                        <div class="color-choice-bar">
                            <span v-for="color in presetColorsList" :key="color.hex" 
                                  class="preset-color-block" 
                                  :class="{ 'is-active': (temp.FinishedColor || '').toLowerCase() === color.hex.toLowerCase() }" 
                                  :style="{ backgroundColor: color.hex }" 
                                  :title="color.label"
                                  @click="temp.FinishedColor = color.hex">
                            </span>
                            <el-color-picker v-model="temp.FinishedColor" size="small" :class="{ 'is-custom-active': isCustomColor(temp.FinishedColor) }" title="自定义颜色 (点击打开调色盘)"></el-color-picker>
                            <span class="color-text-value" :style="{ color: temp.FinishedColor || '#10b981' }">
                                {{ getColorName(temp.FinishedColor || '#10b981') }} ({{ temp.FinishedColor || '#10b981' }})
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item label="内容分屏">
                        <div class="layout-row-content">
                            <el-radio-group v-model="temp.ViolationLayoutMode" size="mini">
                                <el-radio-button :label="0">跟随学校默认</el-radio-button>
                                <el-radio-button :label="1">全屏</el-radio-button>
                                <el-radio-button :label="2">二分屏</el-radio-button>
                                <el-radio-button :label="4">四分屏</el-radio-button>
                            </el-radio-group>
                            <violation-layout-preview
                                :mode="previewLayoutMode"
                                :follow-label="temp.ViolationLayoutMode === 0 ? '跟随学校' : ''"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="temp.Remark" type="textarea" :rows="3" placeholder="备注信息" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveData" :loading="submitLoading">确认</el-button>
                </div>
            </el-dialog>

            <!-- 独立配色设置弹窗 -->
            <el-dialog title="设置大屏配色" :visible.sync="colorDialogVisible" width="700px" append-to-body :close-on-click-modal="false">
                <div class="color-setting-card" v-if="colorTemp">
                    <div class="color-setting-row">
                        <div class="color-label-tag">待放学颜色：</div>
                        <div class="color-choice-bar">
                            <span v-for="color in presetColorsList" :key="color.hex" 
                                  class="preset-color-block" 
                                  :class="{ 'is-active': (colorTemp.PendingColor || '').toLowerCase() === color.hex.toLowerCase() }" 
                                  :style="{ backgroundColor: color.hex }" 
                                  :title="color.label"
                                  @click="colorTemp.PendingColor = color.hex">
                            </span>
                            <el-color-picker v-model="colorTemp.PendingColor" size="small" :class="{ 'is-custom-active': isCustomColor(colorTemp.PendingColor) }" title="自定义颜色 (点击打开调色盘)"></el-color-picker>
                            <span class="color-text-value" :style="{ color: colorTemp.PendingColor || '#3b82f6' }">
                                {{ getColorName(colorTemp.PendingColor || '#3b82f6') }} ({{ colorTemp.PendingColor || '#3b82f6' }})
                            </span>
                        </div>
                    </div>
                    <div class="color-setting-row">
                        <div class="color-label-tag">放学中颜色：</div>
                        <div class="color-choice-bar">
                            <span v-for="color in presetColorsList" :key="color.hex" 
                                  class="preset-color-block" 
                                  :class="{ 'is-active': (colorTemp.DismissingColor || '').toLowerCase() === color.hex.toLowerCase() }" 
                                  :style="{ backgroundColor: color.hex }" 
                                  :title="color.label"
                                  @click="colorTemp.DismissingColor = color.hex">
                            </span>
                            <el-color-picker v-model="colorTemp.DismissingColor" size="small" :class="{ 'is-custom-active': isCustomColor(colorTemp.DismissingColor) }" title="自定义颜色 (点击打开调色盘)"></el-color-picker>
                            <span class="color-text-value" :style="{ color: colorTemp.DismissingColor || '#ef4444' }">
                                {{ getColorName(colorTemp.DismissingColor || '#ef4444') }} ({{ colorTemp.DismissingColor || '#ef4444' }})
                            </span>
                        </div>
                    </div>
                    <div class="color-setting-row">
                        <div class="color-label-tag">已放学颜色：</div>
                        <div class="color-choice-bar">
                            <span v-for="color in presetColorsList" :key="color.hex" 
                                  class="preset-color-block" 
                                  :class="{ 'is-active': (colorTemp.FinishedColor || '').toLowerCase() === color.hex.toLowerCase() }" 
                                  :style="{ backgroundColor: color.hex }" 
                                  :title="color.label"
                                  @click="colorTemp.FinishedColor = color.hex">
                            </span>
                            <el-color-picker v-model="colorTemp.FinishedColor" size="small" :class="{ 'is-custom-active': isCustomColor(colorTemp.FinishedColor) }" title="自定义颜色 (点击打开调色盘)"></el-color-picker>
                            <span class="color-text-value" :style="{ color: colorTemp.FinishedColor || '#10b981' }">
                                {{ getColorName(colorTemp.FinishedColor || '#10b981') }} ({{ colorTemp.FinishedColor || '#10b981' }})
                            </span>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="colorDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveColorConfig" :loading="colorSubmitLoading">确定</el-button>
                </div>
            </el-dialog>

            <!-- 绑定年级查看弹窗（样式参考考勤规则「查看应用部门」）。最后更新：2026-09-30 -->
            <el-dialog :title="gradeViewDialog.title" :visible.sync="gradeViewDialog.visible" width="600px"
                :close-on-click-modal="false" append-to-body custom-class="dsm-grade-view-dialog">
                <div class="dsm-view-head">
                    <div class="dsm-view-head-item">
                        <span class="label">大屏：</span>
                        <span class="val">{{ gradeViewDialog.screenName || '-' }}</span>
                    </div>
                    <div class="dsm-view-head-item">
                        <span class="label">校区：</span>
                        <span class="val">{{ gradeViewDialog.campusName || '-' }}</span>
                    </div>
                    <div class="dsm-view-head-item">
                        <span class="label">总数：</span>
                        <span class="val count-badge">{{ gradeViewDialog.grades.length }} 个年级</span>
                    </div>
                </div>

                <div class="dsm-view-toolbar">
                    <el-input v-model="gradeViewDialog.filterKey" size="small" placeholder="搜索年级名称..."
                        prefix-icon="el-icon-search" clearable class="dsm-view-search-input" />
                    <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllGradeNames">
                        复制全部年级
                    </el-button>
                </div>

                <el-table :data="filteredViewGrades" size="small" max-height="340" border stripe class="dsm-view-table">
                    <el-table-column type="index" label="序号" width="70" align="center" />
                    <el-table-column prop="name" label="年级名称" min-width="260">
                        <template slot-scope="scope">
                            <span class="grade-text">{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <div slot="empty" class="dsm-view-empty">暂无匹配的年级</div>
                </el-table>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="gradeViewDialog.visible = false">关闭</el-button>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import { getScreenList, saveScreen, deleteScreen, getDismissalScreenConfig } from "@/api/dismissal";
import ViolationLayoutPreview from "./ViolationLayoutPreview.vue";
import { getSubGrades } from '../../api/modules/department';
import { getCampusList } from '../../api/modules/misc';
import DepartmentPane from "../../components/DepartmentPane";
import { treeNodeDeptId } from '../../utils/deptCascaderProps';
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";

export default {
    name: "ScreenManager",
    components: { DepartmentPane, Toolbar, ViolationLayoutPreview },
    data() {
        return {
            list: [],
            listLoading: false,
            page: 1,
            pageSize: 10,
            total: 0,
            gradeOptions: [],
            campusOptions: [],
            presetColorsList: [
                { label: "天蓝", hex: "#3b82f6" },
                { label: "深蓝", hex: "#1d4ed8" },
                { label: "中国红", hex: "#e60012" }, // 增加中文特色经典传统颜色：中国红
                { label: "鲜红", hex: "#ef4444" },
                { label: "翡翠绿", hex: "#10b981" },
                { label: "深绿", hex: "#047857" },
                { label: "金黄", hex: "#eab308" },
                { label: "咖啡棕", hex: "#8b5a2b" }, // 增加咖啡棕色，防止拼音“棕色”联想为“中文”的歧义
                { label: "暗黑", hex: "#1e293b" }
            ],
            dialogFormVisible: false,
            dialogStatus: "",
            textMap: {
                update: "编辑大屏",
                create: "新增大屏",
            },
            temp: {
                Id: 0,
                SchId: "",
                ScreenName: "",
                ScreenCode: "",
                CampusId: "",
                GradeIds: [],
                PendingColor: "",
                DismissingColor: "",
                FinishedColor: "",
                Remark: "",
                ViolationLayoutMode: 0,
            },
            schoolDefaultLayout: 1,
            rules: {
                ScreenName: [
                    { required: true, message: "请输入名称", trigger: "blur" },
                ],
                ScreenCode: [
                    { required: true, message: "请输入编码", trigger: "blur" },
                ],
                CampusId: [
                    { required: true, message: "请选择校区", trigger: "change" },
                ],
            },
            submitLoading: false,
            currentSchId: '',
            currentDepartmentName: '',
            buttonList: [],
            gradeViewDialog: {
                visible: false,
                title: '',
                screenName: '',
                campusName: '',
                grades: [],
                filterKey: '',
            },
            searchList: [{ label: "名称", key: "ScreenName" }],
            filters: {},
            currentRow: null,
            // 独立配色弹窗控制变量
            colorDialogVisible: false,
            colorSubmitLoading: false,
            colorTemp: null,
        };
    },
    computed: {
        /** 绑定年级弹窗按关键字过滤后的列表 */
        filteredViewGrades() {
            const list = this.gradeViewDialog.grades || [];
            const key = (this.gradeViewDialog.filterKey || '').trim().toLowerCase();
            return list
                .filter((name) => !key || String(name).toLowerCase().includes(key))
                .map((name) => ({ name }));
        },
        previewLayoutMode() {
            if (this.temp.ViolationLayoutMode === 1 || this.temp.ViolationLayoutMode === 2 || this.temp.ViolationLayoutMode === 4) {
                return this.temp.ViolationLayoutMode;
            }
            return this.schoolDefaultLayout === 2 || this.schoolDefaultLayout === 4 ? this.schoolDefaultLayout : 1;
        }
    },
    mounted() {
        // 模拟或者从存储获取路由数据，根据当前路径匹配按钮
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
    methods: {
        /** 解析后端「、」分隔的年级名称为数组 */
        parseGradeNames(val) {
            if (!val) return [];
            if (Array.isArray(val)) return val;
            return String(val).split('、').map((s) => s.trim()).filter((s) => s.length > 0);
        },
        /** 打开绑定年级查看弹窗 */
        openGradeViewDialog(row) {
            if (!row) return;
            this.gradeViewDialog = {
                visible: true,
                title: `查看绑定年级 - ${row.ScreenName || '大屏'}`,
                screenName: row.ScreenName || '',
                campusName: row.CampusName || '',
                grades: this.parseGradeNames(row.GradeNames),
                filterKey: '',
            };
        },
        /** 复制当前筛选出的全部年级名称 */
        copyAllGradeNames() {
            const names = this.filteredViewGrades.map((item) => item.name).filter(Boolean);
            if (!names.length) {
                this.$message.warning('暂无可复制的年级');
                return;
            }
            const text = names.join('、');
            const done = () => this.$message.success(`已复制 ${names.length} 个年级名称`);
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(done).catch(() => {
                    this.fallbackCopyText(text);
                    done();
                });
            } else {
                this.fallbackCopyText(text);
                done();
            }
        },
        /** 非安全上下文下的剪贴板降级复制 */
        fallbackCopyText(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        },
        treeNodeClick(data, node, component) {
            if (data.value == '0') {
                this.$message.warning('请选择具体的学校或校区进行操作');
                this.currentSchId = '';
                this.currentDepartmentName = '';
                this.list = [];
                this.total = 0;
                this.page = 1;
                return;
            }
            if (data && data.value) {
                this.currentSchId = treeNodeDeptId(data) || String(data.value);
                this.currentDepartmentName = data.label;
                this.page = 1;
                this.handleQuery();
                this.fetchCampuses();
            }
        },
        // 工具栏调用
        callFunction(item) {
            if (typeof item.search == "object") {
                this.filters = item.search;
            } else {
                this.filters = {
                    key: item.search,
                };
            }
            if (item.Func === "handleQuery") {
                this.page = 1;
            }
            // 根据按钮配置 of Func 属性调用对应方法
            // 通常是 handleQuery, handleAdd, handleEdit, handleDel 等
            if (this[item.Func]) {
                this[item.Func].apply(this, item);
            } else {
                console.warn(`Function ${item.Func} not implemented`);
            }
        },
        selectCurrentRow(val) {
            if (val) {
                this.currentRow = val;
                this.$refs.table.setCurrentRow(val);
            }
        },

        handleCurrentChange(val) {
            this.page = val;
            this.handleQuery();
        },

        handleQuery() {
            if (!this.currentSchId) return;
            this.listLoading = true;
            let params = {
                schId: this.currentSchId,
                page: this.page,
                intPageSize: this.pageSize,
                ...this.filters,
            };
            getScreenList(params)
                .then((res) => {
                    if (res.data.success && res.data.response) {
                        const pageData = res.data.response;
                        this.list = pageData.data || [];
                        this.total = pageData.dataCount || 0;
                        this.page = pageData.page || this.page;
                    } else {
                        this.list = [];
                        this.total = 0;
                    }
                    this.currentRow = null;
                    this.listLoading = false;
                    this.$nextTick(() => {
                        this.$refs.table && this.$refs.table.doLayout();
                    });
                })
                .catch(() => {
                    this.list = [];
                    this.total = 0;
                    this.listLoading = false;
                });
        },
        /**
         * 拉取当前机构下的校区选项（学校节点返回全部校区，校区节点只返回自身）
         * @param {string} deptId - 左侧机构树选中的学校/校区 Id
         * @returns {Promise<void>}
         */
        fetchCampuses(deptId) {
            const id = deptId || this.currentSchId;
            if (!id) {
                this.campusOptions = [];
                return Promise.resolve();
            }
            return getCampusList({ page: 1, intPageSize: 999, departmentId: id })
                .then((res) => {
                    const list = res.data.success && res.data.response ? res.data.response.data || [] : [];
                    this.campusOptions = list.map((d) => ({ label: d.Name, value: String(d.Id) }));
                })
                .catch(() => {
                    this.campusOptions = [];
                });
        },
        /**
         * 按校区拉取年级选项（递归，仅年级类型）
         * @param {string} campusId - 校区 Id
         * @returns {Promise<void>}
         */
        fetchGrades(campusId) {
            if (!campusId) {
                this.gradeOptions = [];
                return Promise.resolve();
            }
            return getSubGrades({ pid: campusId })
                .then((res) => {
                    this.gradeOptions = res.data.success
                        ? (res.data.response || []).map((d) => ({ label: d.Name, value: String(d.Id) }))
                        : [];
                })
                .catch(() => {
                    this.gradeOptions = [];
                });
        },
        /** 切换校区：清空已选年级并重新加载该校区年级 */
        handleCampusChange(campusId) {
            this.temp.GradeIds = [];
            this.fetchGrades(campusId);
        },
        formatTime(time) {
            if (!time || time === "0001-01-01T00:00:00") return "";
            const d = new Date(time);
            return (
                d.getFullYear() +
                "-" +
                String(d.getMonth() + 1).padStart(2, "0") +
                "-" +
                String(d.getDate()).padStart(2, "0") +
                " " +
                String(d.getHours()).padStart(2, "0") +
                ":" +
                String(d.getMinutes()).padStart(2, "0")
            );
        },
        resetTemp() {
            this.temp = {
                Id: 0,
                SchId: this.currentSchId,
                ScreenName: "",
                ScreenCode: "",
                CampusId: "",
                GradeIds: [],
                PendingColor: "#3b82f6",     // 默认待放学为明亮蓝色
                DismissingColor: "#ef4444",  // 默认放学中为高亮红色
                FinishedColor: "#10b981",    // 默认已放学为翡翠绿色
                Remark: "",
                ViolationLayoutMode: 0,
            };
        },
        loadSchoolDefaultLayout() {
            if (!this.currentSchId) return;
            getDismissalScreenConfig({ departmentId: this.currentSchId }).then(res => {
                const r = res && res.data && res.data.response ? res.data.response : null;
                const layout = r ? (r.violationLayoutMode != null ? r.violationLayoutMode : r.ViolationLayoutMode) : 1;
                this.schoolDefaultLayout = layout === 2 || layout === 4 ? Number(layout) : 1;
            }).catch(() => { this.schoolDefaultLayout = 1; });
        },
        generateRandomCode() {
            // 生成6位随机数字
            this.temp.ScreenCode = Math.floor(100000 + Math.random() * 900000).toString();
        },
        handleAdd() {
            if (!this.currentSchId) {
                this.$message.warning("请先选择左侧学校/机构");
                return;
            }
            this.resetTemp();
            this.generateRandomCode();
            this.gradeOptions = [];
            this.dialogStatus = "create";
            this.dialogFormVisible = true;
            // 只有一个校区时默认选中
            this.fetchCampuses().then(() => {
                if (this.campusOptions.length === 1 && !this.temp.CampusId) {
                    this.temp.CampusId = this.campusOptions[0].value;
                    this.fetchGrades(this.temp.CampusId);
                }
            });
            this.loadSchoolDefaultLayout();
            this.$nextTick(() => {
                if (this.$refs["dataForm"]) this.$refs["dataForm"].clearValidate();
            });
        },
        handleEdit(row) {
            // 兼容行内点击和工具栏点击
            if (!row || row.type === "click") {
                // row.type check for event object if passed directly
                row = this.currentRow;
            }
            if (!row) {
                this.$message.warning("请选择要编辑的数据");
                return;
            }

            const targetSchId = row.SchId || this.currentSchId;
            this.loadSchoolDefaultLayout();

            // 回填顺序：校区 → 拉该校区年级 → 回填年级；历史跨校区数据需重新选择校区
            const campusId = row.CampusId ? String(row.CampusId) : "";
            const rowGradeIds = row.GradeIds && row.GradeIds.length > 0 ? row.GradeIds.split(",") : [];
            this.gradeOptions = [];
            this.fetchCampuses();
            if (campusId) {
                this.fetchGrades(campusId).then(() => {
                    if (this.temp.Id === row.Id && this.temp.CampusId === campusId) {
                        this.temp.GradeIds = rowGradeIds;
                    }
                });
            } else if (rowGradeIds.length > 0) {
                this.$message.warning("该大屏绑定的年级跨多个校区，请重新选择校区和年级");
            }

            this.temp = {
                Id: row.Id,
                SchId: targetSchId,
                ScreenName: row.ScreenName,
                ScreenCode: row.ScreenCode,
                CampusId: campusId,
                GradeIds: [],
                PendingColor: row.PendingColor || "#3b82f6",
                DismissingColor: row.DismissingColor || "#ef4444",
                FinishedColor: row.FinishedColor || "#10b981",
                Remark: row.Remark,
                ViolationLayoutMode: row.ViolationLayoutMode === 1 || row.ViolationLayoutMode === 2 || row.ViolationLayoutMode === 4
                    ? Number(row.ViolationLayoutMode)
                    : 0,
            };
            this.dialogStatus = "update";
            this.dialogFormVisible = true;
            this.$nextTick(() => {
                if (this.$refs["dataForm"]) this.$refs["dataForm"].clearValidate();
            });
        },
        saveData() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    const params = {
                        ...this.temp,
                        GradeIds: this.temp.GradeIds.map(String),
                        PendingColor: this.temp.PendingColor || "",
                        DismissingColor: this.temp.DismissingColor || "",
                        FinishedColor: this.temp.FinishedColor || "",
                    };

                    saveScreen(params)
                        .then((res) => {
                            if (res.data.success) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                });
                                this.dialogFormVisible = false;
                                this.handleQuery();
                            } else {
                                this.$message.error(res.data.msg || "保存失败");
                            }
                            this.submitLoading = false;
                        })
                        .catch((e) => {
                            this.submitLoading = false;
                            this.$message.error("保存异常");
                        });
                }
            });
        },
        handleDel(row) {
            if (!row || row.type === "click") {
                row = this.currentRow;
            }
            if (!row) {
                this.$message.warning("请选择要删除的数据");
                return;
            }
            this.$confirm("确认删除该设备: " + row.ScreenName + " ?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteScreen({ id: row.Id }).then((res) => {
                        if (res.data.success) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.handleQuery();
                        } else {
                            this.$message.error(res.data.msg || "删除失败");
                        }
                    });
                })
                .catch(() => { });
        },
        getScreenUrl(code) {
            return `https://webh5.yiqiba.xin/DismissalBigScreen?code=${code}`;
        },
        handleCopyLink(code) {
            if (!code) {
                this.$message.warning("无编码，无法生成链接");
                return;
            }
            const url = this.getScreenUrl(code);
            const input = document.createElement("input");
            input.value = url;
            document.body.appendChild(input);
            input.select();
            document.execCommand("Copy");
            document.body.removeChild(input);
            this.$message.success("链接已复制到剪贴板");
        },
        handleOpenLink(code) {
            if (!code) {
                this.$message.warning("无编码，无法打开链接");
                return;
            }
            const url = this.getScreenUrl(code);
            window.open(url, "_blank");
        },
        openColorDialog(row) {
            // 深度克隆配色数据给临时对象，保证在没有确认保存前不影响主表数据展示
            this.colorTemp = {
                Id: row.Id,
                SchId: row.SchId,
                ScreenName: row.ScreenName,
                ScreenCode: row.ScreenCode,
                GradeIds: row.GradeIds ? row.GradeIds.split(",") : [],
                PendingColor: row.PendingColor || "#3b82f6",
                DismissingColor: row.DismissingColor || "#ef4444",
                FinishedColor: row.FinishedColor || "#10b981",
                Remark: row.Remark,
            };
            this.colorDialogVisible = true;
        },
        saveColorConfig() {
            if (!this.colorTemp) return;
            this.colorSubmitLoading = true;
            
            // 组装入参，把年级 Id 列表转为字符串数组传给保存接口
            // 仅改配色时不传校区，后端保留原校区与年级不重新校验
            const params = {
                ...this.colorTemp,
                CampusId: null,
                GradeIds: this.colorTemp.GradeIds.map(String),
                PendingColor: this.colorTemp.PendingColor || "",
                DismissingColor: this.colorTemp.DismissingColor || "",
                FinishedColor: this.colorTemp.FinishedColor || "",
            };

            saveScreen(params)
                .then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: "保存状态配色成功",
                            type: "success",
                        });
                        this.colorDialogVisible = false;
                        this.handleQuery(); // 配色成功保存后，自动刷新列表拉取最新数据
                    } else {
                        this.$message.error(res.data.msg || "保存配色失败");
                    }
                    this.colorSubmitLoading = false;
                })
                .catch(() => {
                    this.colorSubmitLoading = false;
                    this.$message.error("保存配色异常");
                });
        },
        isCustomColor(colorHex) {
            if (!colorHex) return false;
            // 判断当前色值是否属于 9 种快捷预设色之一。如果不属于任何一个，则说明是自定义色值
            return !this.presetColorsList.some(
                (c) => c.hex.toLowerCase() === colorHex.toLowerCase()
            );
        },
        // 将十六进制颜色值解析为 RGB 数组，供最近邻色彩匹配使用
        hexToRgbArray(hex) {
            if (!hex) return [0, 0, 0];
            let s = hex.replace("#", "");
            if (s.length === 3) {
                s = s[0] + s[0] + s[1] + s[1] + s[2] + s[2];
            }
            const num = parseInt(s, 16);
            return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
        },
        // 利用 RGB 三维空间欧氏距离最邻近算法匹配色值对应的优雅中文颜色名
        getColorName(colorHex) {
            if (!colorHex) return "未指定";
            
            const colorMap = [
                { name: "天蓝色", hex: "#3b82f6", rgb: [59, 130, 246] },
                { name: "深蓝色", hex: "#1d4ed8", rgb: [29, 78, 216] },
                { name: "中国红", hex: "#e60012", rgb: [230, 0, 18] },
                { name: "鲜红色", hex: "#ef4444", rgb: [239, 68, 68] },
                { name: "翡翠绿", hex: "#10b981", rgb: [16, 185, 129] },
                { name: "深绿色", hex: "#047857", rgb: [4, 120, 87] },
                { name: "金黄色", hex: "#eab308", rgb: [234, 179, 8] },
                { name: "咖啡棕", hex: "#8b5a2b", rgb: [139, 90, 43] },
                { name: "暗黑色", hex: "#1e293b", rgb: [30, 41, 59] },
                { name: "玫瑰粉", hex: "#ec4899", rgb: [236, 72, 153] },
                { name: "紫罗兰", hex: "#8b5cf6", rgb: [139, 92, 246] },
                { name: "薄荷绿", hex: "#14b8a6", rgb: [20, 184, 166] },
                { name: "珊瑚橙", hex: "#f97316", rgb: [249, 115, 22] },
                { name: "纯白色", hex: "#ffffff", rgb: [255, 255, 255] }
            ];

            // 1. 优先执行精确匹配
            const exactMatch = colorMap.find(c => c.hex.toLowerCase() === colorHex.toLowerCase());
            if (exactMatch) {
                return exactMatch.name;
            }

            // 2. 自定义颜色，智能搜索距离最近的经典色名并标记为自定义
            const targetRgb = this.hexToRgbArray(colorHex);
            let minDistance = Infinity;
            let closestColorName = "自定义";

            colorMap.forEach(c => {
                const dist = Math.pow(targetRgb[0] - c.rgb[0], 2) +
                             Math.pow(targetRgb[1] - c.rgb[1], 2) +
                             Math.pow(targetRgb[2] - c.rgb[2], 2);
                if (dist < minDistance) {
                    minDistance = dist;
                    closestColorName = c.name;
                }
            });

            return closestColorName + "(自定义)";
        },
    },
};
</script>

<style scoped>
/* 解决表格单元格 overflow 剪裁 hover 放大色球的 Bug */
::v-deep .el-table .color-column .cell {
  overflow: visible !important;
}

/* 列表状态配色圆点徽章 */
.table-color-preview {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.color-badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  user-select: none;
  border: 1.5px solid rgba(255, 255, 255, 0.6);
}
.color-badge:hover {
  transform: scale(1.2) translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* 状态配色磁贴色块 */
.color-choice-bar {
  display: flex;
  align-items: center;
  gap: 8px;
}
.preset-color-block {
  width: 26px; /* 调大一点，更容易点击 */
  height: 26px;
  border-radius: 50%; /* 更改为精致的圆形糖果小球 */
  cursor: pointer;
  border: 2px solid #ffffff; /* 细白色内描边 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15); /* 底部微阴影 */
  box-sizing: border-box;
  display: inline-block; /* 核心修正：防止 span 没有内容时高度坍塌 */
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0; /* 绝对防止在小空间下被挤压变形 */
}
.preset-color-block:hover {
  transform: scale(1.2) translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}
.preset-color-block.is-active {
  border-color: #ffffff !important;
  box-shadow: 0 0 0 2.5px var(--btn-primary, #2563eb), 0 4px 10px rgba(64, 158, 255, 0.5); /* 选中时呈现精致的蓝白双层外环发光 */
  transform: scale(1.15);
}

/* 配色弹窗布局 */
.color-setting-card {
  padding: 10px 20px;
}
.color-setting-row {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}
.color-setting-row:last-child {
  margin-bottom: 5px;
}
.color-label-tag {
  width: 100px;
  font-size: 14px;
  color: #606266;
  font-weight: bold;
  flex-shrink: 0; /* 绝对防止字折行 */
  white-space: nowrap; /* 强制在一行内完全展示 */
}

/* 将 el-color-picker 触发器按钮彻底伪装成圆球，与左侧小棋子绝对对齐 */
::v-deep .el-color-picker {
  height: 26px !important;
  line-height: 26px !important;
  vertical-align: middle;
  margin-left: 10px;
  flex-shrink: 0; /* 绝对防止调色球被挤扁 */
}
::v-deep .el-color-picker__trigger {
  width: 26px !important;
  height: 26px !important;
  border-radius: 50% !important; /* 完美圆角 */
  border: 2px solid #ffffff !important; /* 白色边框与左侧一致 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15) !important;
  box-sizing: border-box;
  padding: 0 !important;
  background: transparent !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
}
::v-deep .el-color-picker__trigger:hover {
  transform: scale(1.2) translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25) !important;
}
::v-deep .el-color-picker__color {
  border: none !important;
  border-radius: 50% !important;
}
::v-deep .el-color-picker__color-inner {
  border-radius: 50% !important;
}
::v-deep .el-color-picker__icon {
  display: none !important; /* 去除不好看的下拉小箭头 */
}

/* 当调色值为自定义颜色时，激活第 8 个自定义圆棋子的双层白蓝发光环 */
.is-custom-active ::v-deep .el-color-picker__trigger {
  border-color: #ffffff !important;
  box-shadow: 0 0 0 2.5px var(--btn-primary, #2563eb), 0 4px 10px rgba(64, 158, 255, 0.5) !important;
  transform: scale(1.15);
}

/* 在调色小球内部通过纯 CSS 几何图形精准绘制白色加号（'+'），挂载在颜色 inner 上，确保始终在背景色之上绘制且绝不坍塌 */
::v-deep .el-color-picker__color-inner::after {
  content: '' !important;
  display: block !important; /* 强制块级显示，防止清除浮动等污染 */
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  width: 10px !important; /* 加号横线长度 */
  height: 2px !important; /* 加号横线厚度 */
  background-color: #ffffff !important;
  transform: translate(-50%, -50%) !important;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.4) !important;
  pointer-events: none !important;
  opacity: 0.9 !important;
  z-index: 10 !important; /* 强行置顶，防止被 inner 背景遮挡 */
  transition: all 0.2s ease !important;
}
::v-deep .el-color-picker__color-inner::before {
  content: '' !important;
  display: block !important; /* 强制块级显示，防止清除浮动等污染 */
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  width: 2px !important; /* 加号竖线厚度 */
  height: 10px !important; /* 加号竖线长度 */
  background-color: #ffffff !important;
  transform: translate(-50%, -50%) !important;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.4) !important;
  pointer-events: none !important;
  opacity: 0.9 !important;
  z-index: 10 !important; /* 强行置顶，防止被 inner 背景遮挡 */
  transition: all 0.2s ease !important;
}

/* 悬停时加高加号亮度 */
::v-deep .el-color-picker__trigger:hover .el-color-picker__color-inner::after,
::v-deep .el-color-picker__trigger:hover .el-color-picker__color-inner::before {
  opacity: 1 !important;
}

/* 列表「已绑定 N 个年级」入口（与考勤规则「已选 N 个部门」一致）。最后更新：2026-09-30 */
.dsm-grade-link-btn {
  padding: 4px 10px;
  font-size: 13px;
  color: #2563eb;
  background-color: #eff6ff;
  border-radius: 4px;
  line-height: 18px;
  border: 1px solid #bfdbfe;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}
.dsm-grade-link-btn:hover,
.dsm-grade-link-btn:focus {
  color: #1d4ed8;
  background-color: #dbeafe;
  border-color: #93c5fd;
}
.dsm-scope-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  padding: 2px 8px;
}

/* 绑定年级查看弹窗 */
.dsm-view-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 14px;
}
.dsm-view-head-item {
  font-size: 13px;
  color: #334155;
}
.dsm-view-head-item .label {
  color: #64748b;
}
.dsm-view-head-item .val {
  font-weight: 500;
  color: #0f172a;
}
.dsm-view-head-item .count-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}
.dsm-view-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.dsm-view-search-input {
  max-width: 280px;
}
.dsm-view-table .grade-text {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
}
.dsm-view-empty {
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
}

/* 历史大屏年级跨校区提示 */
.campus-warn {
  color: #e6a23c;
  font-weight: 600;
}

/* 表格操作列排版容器 */
.table-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}
/* fixed 列是独立叠加的表格，单元格统一不换行，保证与主表行高一致 */
.tbl-scroll-host ::v-deep .el-table .cell {
  white-space: nowrap;
}
.layout-row-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

/* 颜色十六进制代码文本预览样式 */
.color-text-value {
  font-family: Consolas, Monaco, monospace;
  font-size: 13px;
  font-weight: 700;
  margin-left: 12px;
  padding: 3px 8px;
  background-color: #f8fafc;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  min-width: 140px;
  white-space: nowrap; /* 强行一行展示，防止被折行 */
  text-align: center;
  display: inline-block;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
  user-select: all;
  flex-shrink: 0; /* 绝对防止文本被挤扁 */
}
</style>
